import React from 'react';
import PropTypes from 'prop-types';

const COLOR_MAP = {
  yellow: 'dots-actions__popover--yellow',
  red: 'dots-actions__popover--red',
  default: 'dots-actions__popover',
};

const PopoverMenuItem = props => (
  <li
    onKeyDown={() => {}}
    onClick={props.onClick}
    role="menuitem"
    className={`list-group-item ${COLOR_MAP[props.color]}`}
  >
    {props.label}
  </li>
);

PopoverMenuItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string,
  label: PropTypes.string.isRequired,
};

PopoverMenuItem.defaultProps = {
  color: 'default',
};

export default PopoverMenuItem;
